<template>
    <div class="review-actions">
        <button v-if="props.detail.is_hidden" class="btn" @click="doUnhide">Показать</button>
        <button v-else class="btn btn--danger" @click="doHide">Скрыть</button>
        <button class="btn btn--danger" @click="doMarkInappropriate">Отметить как неприемлемый</button>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ detail: { id: string | number; is_hidden?: boolean } }>();
const route = useRoute();

function endpointPrefix(): string {
    const modelLabel = route.params.modelLabel as string;
    return modelLabel === 'reviews.eventreview' ? 'event-reviews' : 'user-reviews';
}

const reviewId = (): string => String(props.detail.id);

async function doHide(): Promise<void> {
    const reason = window.prompt('Укажите причину скрытия (необязательно):') ?? '';
    if (reason === null) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/hide/`,
        data: { reason },
    });
    window.location.reload();
}

async function doUnhide(): Promise<void> {
    if (!window.confirm('Показать отзыв?')) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/unhide/`,
        data: {},
    });
    window.location.reload();
}

async function doMarkInappropriate(): Promise<void> {
    if (!window.confirm('Отметить отзыв как неприемлемый?')) return;
    await request({
        method: 'post',
        url: `/admin-api/${endpointPrefix()}/${reviewId()}/mark-inappropriate/`,
        data: {},
    });
    window.location.reload();
}
</script>

<style scoped>
.review-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .review-actions .btn { min-height: 2.5rem; }
}
</style>
